export default {
    Default: 20
}